import {
  MarketplaceItemService as Service,
  Model,
} from '@/internal';

export default class MarketplaceItem extends Model {

  static get key() {
    return 'marketplaceItem';
  }

  static get service() {
    return Service;
  }

  static get fields() {
    return {};
  }
}
